import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Always put side effects last",
  "description": "",
  "published": "2018-01-10T00:00:00.000Z",
  "redirect_from": ["/blog/always-put-side-effects-last/swizec/8057"],
  "categories": "Startups, Technical",
  "hero": "./img/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/638d71778e30644965b76d71d836e053/72e01/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "34.97757847533632%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'140\\'%20viewBox=\\'0%200%20400%20140\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2018v19h16l16-1h8l8-1a89%2089%200%200132%202l18-1c13-1%2018-1%2020-3h7l-1-1c-2%200%201-3%204-3l3-2c3-1%2020%201%2021%203l5%202%208%201c9%202%2014%203%2023%203l31-3%205%201h5l1-1c1%201%202-1%203-5%202-12%206-22%205-11-2%2011-2%2015-1%2015l1-1h1c1%201%201%201%201-1%200-4%202-7%203-6l-1%203c-2%205-2%208-1%207%202%200%202%201%201%203-2%202-2%203-1%203l6%201-2%201h-3v9l1%2010c0%202%2018%202%2018%200l-8-1c-7%201-11%200-7-1l14-1c10%200%2012-1%2011-2h-2c-1%201-1%201-1-2v-3l-1%203-1%202-10-1c-10%201-13%200-9-1l16-1c3%201%203%200%203-2l1-3c2%202%203-1%203-9v-7l13-1%2013-1a193%20193%200%200152%201l2-1%202-1%204-1%204%201%2016%201c24-1%2024-1%2024%203l1-15V0H0v18m260%2055c0%202%200%202-2%202s-3%201-3%203l-1%203v-3c0-3%200-3-5-3-6%201-5%200-6%208l-1%205-1%202c1%201%200%201-1%201l-2-1h1l1-2c0-1-1-2-6-2h-7l4%201%203%201%201%201h1c1%201-1%201-4%201-4%200-4%200-2%201l3%201h1l4%202h-5c-8%200-8%200-5%201%202%201%205%202%206%201l1%201%203%201c1%201%200%201-3%201h-6l4%202c4%201%204%202%202%202-4%200-11-2-10-3l2-1c2%200%202%200%200-1h-14l-7%201c-1-1-1-1%201-1%203%200%204-2%200-2l-3%201h-5c0-2-7-3-10-2h-10c-9%201-11%202-11%205-1%201-1%201-1-1%201-5%203-4-20-4-14%200-39-3-43-4h-2a858%20858%200%2000-4%204v-1c2%200%201-2-1-2l-2%202-1%202-1-1-1-2-1%202c0%202-1%203-3%203l-3%202h-4l2-1%201-1-3-1c-3%200-4%201-2%202%201%201%200%206-2%205l-1-1-2-1-2%201h-4l-3-1h-1l-2%201v1l1%205c-1%205-1%205%205%205%204%200%204%200%204-2-1-3%201-6%203-4v2l-1%202-1%203-2%203h-2l-2-1-2-1-4-1h-1l-4-3c-2-2-3-3-2-4%201%200%201-1-1-3l-1-2h7l-4-2-6-1h-5l1-2h3l-3-1-3%201-2%201c-2%200-2%200-1%201s1%202-1%203h-6l-2-1-2-1-6-1c-3%201-7%200-9-1H8l-2%201-2%202H3c-1-2-2-1-3%203%200%202%200%203%202%203v1c-2%200-2%201-2%2016v15h14c12%200%2014-1%2012-2v-1l3%201c2%202%2013%202%2013%200l7%201%2017%201c14%200%2016%200%2018-2l3-1v2c-1%201%2017%201%2054%201h55v-3c0-1%200-2%201-1l1%202c0%202%201%202%2014%202%2012%200%2013%200%2012-2-2-2%200-2%203%200l7%202h4l-5-1-10-6%209%203%209%204h76v-8l-1-8h-2l-4-1c-2-1-4-1-3-2%200-1%202-1%206%201v-2h3c6%201%208%204%208%2011v6l-1-5c0-9-2-8-2%200v8h80l-1-30-1-31a633%20633%200%2000-83%204%20243%20243%200%2001-39%200c2%200%202%200%200-1-2%200-3-1-3-4%200-4-4-5-4-1%200%202%200%202-1%200%200-1-1-2-3-2s-2-1-2-3l-1%203-1%206v-5l-1-6-1%203m-69%208l-10%201-9%201h7l9%201c6%202%2037%203%2037%201-1-2-9-4-21-4h-13m34%2023v3l-1%202%201%201v1c-1%201-1%206%201%208v1c-2-1-2-1-2%201v9l10%204c2%200%202%200%200-1l-3-2-4-2c-2-2-2-2%200-1%2010%203%2014%204%209%201-3-2-5-3-6-2l-1-1-2-2%204%201h5l-2-2-2-1-4-1c-1-1%200-1%204-1h4l-2-1-3-1-5-2%203-1%208%201-4-2-4-2h2c5%200%205%200%204-1l-4-2-3-1c-1-1%200-1%205-1%206%201%206%201-3-3h-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/638d71778e30644965b76d71d836e053/ca0a1/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.webp 223w", "/static/638d71778e30644965b76d71d836e053/75680/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.webp 445w", "/static/638d71778e30644965b76d71d836e053/8d1ba/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.webp 890w", "/static/638d71778e30644965b76d71d836e053/a9a89/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.webp 1024w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/638d71778e30644965b76d71d836e053/853b2/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.jpg 223w", "/static/638d71778e30644965b76d71d836e053/0a4fe/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.jpg 445w", "/static/638d71778e30644965b76d71d836e053/7f80b/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.jpg 890w", "/static/638d71778e30644965b76d71d836e053/72e01/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.jpg 1024w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/638d71778e30644965b76d71d836e053/7f80b/wp-content-uploads-2016-10-salesforce-tower-panorama-1024x358.jpg",
              "alt": "wp content uploads 2016 10 salesforce tower panorama 1024x358",
              "title": "wp content uploads 2016 10 salesforce tower panorama 1024x358",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You know how some lessons you can only learn from experience? This is such a lesson. I'm sharing it with you so that I may remember it better.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`That thing that you can't learn in a 6 month bootcamp but takes years of trial and error to hone. I don't know a name for it.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/950152073819009024"
      }}>{`January 7, 2018`}</a></blockquote>
    <p>{`Let's say you're building a system for drip campaigns. Because that's how I learned this lesson.`}</p>
    <p>{`Your system is given a set of leads. You have to send them a series of messages, update metadata in your database, and keep the sales CRM (customer relationship management) system up-to-date so when a lead eventually replies to your message, a sales person knows what to do.`}</p>
    <p>{`Hundreds of these systems have been developed by thousands of developers. You're building your own because startups.`}</p>
    <p>{`The core of your system is a `}<inlineCode parentName="p">{`send_next_message`}</inlineCode>{` function. Something like this 👇`}</p>
    <pre><code parentName="pre" {...{}}>{`def send_next_message(lead)
    campaign = lead.campaign
    Twilio.send_message(lead, campaign.message)
    CRM.update_data(lead)
    campaign.advance_to_next_message
end
`}</code></pre>
    <p>{`It makes sense, right? You take the drip campaign, send the current message with Twilio, update some metadata on your CRM, then advance your campaign to the next message.`}</p>
    <p>{`Works perfect 👌`}</p>
    <p>{`You run it in a cronjob once a day. Like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`def send_campaigns
    Lead.active.each do |lead|
        send_next_message.perform_async(lead)
    end
end
`}</code></pre>
    <p>{`You go through active leads, pick their campaign, and spawn a new background worker with `}<inlineCode parentName="p">{`perform_async`}</inlineCode>{`. Eventually, your queue will run the code and send your campaign.`}</p>
    <p>{`If anything goes wrong, each campaign is isolated in its own worker. Errors don't affect other campaigns. 👌`}</p>
    <p>{`Even better, if something goes wrong while sending the campaign, you can retry the worker.`}</p>
    <h2 {...{
      "id": "and-youve-just-spammed-your-leads-and-made-them-angry"
    }}>{`And you've just spammed your leads and made them angry`}</h2>
    <p>{`Let's review our `}<inlineCode parentName="p">{`send_next_message`}</inlineCode>{` code.`}</p>
    <pre><code parentName="pre" {...{}}>{`def send_next_message(lead)
    campaign = lead.campaign
    Twilio.send_message(lead, campaign.message)
    CRM.update_data(lead)
    campaign.advance_to_next_message
end
`}</code></pre>
    <p>{`An error can happen at any point here.`}</p>
    <p>{`Maybe something goes wrong when you read campaigns from the database. The worker terminates on 1st instruction, and all is good.`}</p>
    <p>{`Things can go wrong when talking to Twilio as well. Their service could be down, your internet could act up, or something else entirely. The worker terminates on 2nd instruction, and all is still good.`}</p>
    <p>{`What if things break when updating your CRM? Third party service, complex set of instructions with multiple API calls, a lot can go wrong.`}</p>
    <p>{`Worker terminates on 3rd instruction.`}</p>
    <p>{`Now you're in trouble. You've already sent a message to your user, but you weren't able to save that info. Your system doesn't know sending happened, and your CRM doesn't know either.`}</p>
    <p>{`When the worker retries, you send the message again.`}</p>
    <p>{`And again. And again. Until the whole worker succeeds.`}</p>
    <p>{`😅`}</p>
    <p>{`Your lead just got a bazillion messages, and they're upset.`}</p>
    <p>{`Here's what you should do instead 👇`}</p>
    <pre><code parentName="pre" {...{}}>{`def send_next_message(lead)
    campaign = lead.campaign
    message = campaign.message
    CRM.update_data(lead)
    campaign.advance_to_next_message
    Twilio.send_message(lead, campaign.message)
end
`}</code></pre>
    <p>{`Fetch campaign, save the message in a local variable. `}<em parentName="p">{`Then`}</em>{` update data in your CRM. Now if updating the CRM fails, you can keep retrying until it succeeds.`}</p>
    <p>{`Updating the CRM was least reliable in my experience.`}</p>
    <p>{`After updating the CRM, you update your local database. This is a reliable operation, but the most common source of programmer errors and `}<inlineCode parentName="p">{`nil`}</inlineCode>{` failures. It happens.`}</p>
    <p>{`Break fast and move things, right? :)`}</p>
    <p>{`At the end, when you're absolutely certain all your data is updated, you send the message to your lead. This is least likely to fail, and if it does, screw it.`}</p>
    <p>{`With this approach, you are guaranteed never to spam your leads. The worst that could happen is that you advance the campaign too early and they get 4 messages instead of 5 and your sales pitch is less polished.`}</p>
    <p>{`That's okay 🙏🏻 Your copy is robust, and annoying people is bad.`}</p>
    <p>{`And now I know why sales automation companies have so much money. This stuff is hard. 😅`}</p>
    <p><strong parentName="p">{`PS:`}</strong>{` There are ways to further improve your worker. You could do your DB first, then rollback if an error occurs. You could try to rollback changes on the CRM if sending fails etc. But that gets complicated fast.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      